import styled from "styled-components";

export const Content = styled.div`
    margin-top: 3rem;
    width: 100%;
    text-align: center;

    a {
        text-decoration: none;
        color: purple;
    }

    a:hover {
        color: rgb(38, 195, 255);
    }
`